module.exports = __webpack_public_path__ + "static/media/Happiny_gaussian2.844cfc51.png";